export default __webpack_public_path__ + "static/media/about-img-04@small.abd9b952.jpg";